import { Outlet } from 'react-router-dom'
import style from './style.module.scss'
import cx from 'classnames'
import { Text } from '@crossfit/design-system'
import {
  Mobile as HeaderMobile,
  Desktop as HeaderDesktop,
} from 'components/Admin/Shared/Menu/Shared/Header'
import Menu from 'components/Admin/Shared/Menu'
import { NavContextProvider } from 'components/Admin/Shared/Menu/Shared/context'
import { useIsLaptopOrAbove } from 'hooks/useMediaQuery'

function AdminContainer() {
  const isLaptopOrAbove = useIsLaptopOrAbove()

  return (
    <NavContextProvider>
      <div className={cx(style.wrapper, {})}>
        <aside className={style.asideWrapper}>
          <div className={style.asideContainer}>
            {isLaptopOrAbove ? <HeaderDesktop /> : <HeaderMobile />}
            <Menu />
          </div>
        </aside>
        <div className={cx(style.pageWrapper, {})}>
          <Outlet />
          <section className={style.pageFooter}>
            <Text as='p' type='body' size='sm'>
              © 2022 CrossFit, LLC, CrossFit, Forging Elite Fitness,
              3...2...1...Go! CrossFit, Fittest on Earth and Sport of Fitness
              are trademarks of CrossFit, LLC in the U.S. and/or other
              countries. All Rights Reserved.
            </Text>
          </section>
        </div>
      </div>
    </NavContextProvider>
  )
}

export default AdminContainer
